import { render, staticRenderFns } from "./InfoBadgeOffline.vue?vue&type=template&id=056fbbd3"
import script from "./InfoBadgeOffline.vue?vue&type=script&lang=js"
export * from "./InfoBadgeOffline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports